<template>
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-project @node-click="nodeClick"></erp-project>
    </div>

    <div class="d-flex-right">
      <!-- 操作按钮 -->
      <div style="margin-bottom: 20px;">
        <el-button type="primary" @click="openAddForm()">添加</el-button>
      </div>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        v-loading="loading"
        border
        style="width: 100%"
        max-height="600"
      >
        <el-table-column prop="project_name" label="项目" width="200"></el-table-column>
        <el-table-column prop="charge_item_name" label="费项">
        </el-table-column>
        <el-table-column prop="valid_time" label="有效时间" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.is_long_time">长期有效</div>
            <div v-else>
              {{ scope.row.valid_time_start }} 至 {{ scope.row.valid_time_end }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="pay_limit" label="最低缴款比例(%)" width="150"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="openEditForm(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="deleteItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap" style="margin-top: 20px; text-align: right;">
        <el-pagination
          background
          layout="prev, pager, next, total"
          :total="total"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>

      <!-- 添加/编辑表单弹窗 -->
      <el-dialog :title="formTitle" :visible.sync="dialogVisible" width="600px">
        <el-form :model="form" :rules="formRules" ref="form" label-width="120px">
          <el-form-item label="项目" prop="project_id">
            <el-select v-model="form.pindex_id" placeholder="请选择项目" style="width: 100%" :disabled="!!form.id" filterable>
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="费项" prop="fee_item">
            <el-select
              v-model="form.fee_item"
              multiple
              filterable
              placeholder="请选择费项"
              style="width: 100%"
            >
              <el-option
                v-for="item in feeItemList"
                :key="item.id"
                :label="item.chargeItem_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="长期有效" prop="is_long_time">
            <el-switch
              v-model="form.is_long_time"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="有效时间" prop="valid_time" v-if="!form.is_long_time">
            <el-date-picker
              v-model="validTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="最低缴款比例(%)" prop="pay_limit">
            <el-input-number v-model="form.pay_limit" :min="1" :max="100" :precision="2" :step="0.1" style="width: 100%"></el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm()">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ErpProject from "../Common/erp-project";

export default {
  name: 'DiscountSetting',
  components: {ErpProject},
  data () {
    return {
      pindex_id: 0,
      tableData: [],
      loading: false,
      total: 0,
      pageSize: 10,
      currentPage: 1,
      dialogVisible: false,
      formTitle: '',
      editMode: false,
      form: {
        id: null,
        pindex_id: '',
        fee_item: [], // 改为数组
        is_long_time : 0,
        valid_start_time: '',
        valid_end_time: '',
        pay_limit: 100
      },
      validTimeRange: [], // 用于日期范围选择器
      projectList: [], // 项目列表
      feeItemList: [], // 费项选项列表
      formRules: {
        pindex_id: [
          { required: true, message: '请选择项目', trigger: 'change' }
        ],
        fee_item: [
          { required: true, message: '请选择费项', trigger: 'change' },
          { type: 'array', min: 1, message: '至少选择一个费项', trigger: 'change' }
        ],
        pay_limit: [
          { required: true, message: '请输入最低缴款比例', trigger: 'blur' },
          { type: 'number', min: 1 , max: 100, message: '最低缴款比例必须在0-100之间', trigger: 'blur' }
        ]
      }
    }
  },
  //界面没出来前加载
  created() {
    this.fetchData();
    this.fetchProjectList();
    this.getFeeItemName()
  },
  mounted(){
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  methods: {
    nodeClick(e){
      this.pindex_id = e.id;
      this.fetchData();
    },

    // 获取数据列表
    fetchData() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        pindex_id: this.pindex_id
      };

      this.$myhttp
        .post("admin/PartPay/getList", params ,{
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          this.loading = false;
          if (backdata.data.code == 200) {
            this.tableData = backdata.data.data.list || [];
            this.total = backdata.data.data.total || 0;
          } else {
            this.$message.error(backdata.data.msg || '获取数据失败');
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.message || '获取数据失败');
        });
    },

    // 获取项目列表
    fetchProjectList() {
      this.$myhttp
        .get("admin/common/pindex", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.projectList = backdata.data.data;
          } else {
            this.$message.error(backdata.data.message);
          }
        });
    },

    // 打开添加表单
    openAddForm() {
      this.editMode = false;
      this.formTitle = '添加折扣设置';
      this.resetForm();
      this.dialogVisible = true;
    },

    // 打开编辑表单
    openEditForm(row) {
      this.editMode = true;
      this.formTitle = '修改折扣设置';
      // 处理fee_item，如果是字符串则分割为数组
      const formRow = { ...row };
      if (typeof row.charge_item_id === 'string') {
        formRow.fee_item = row.charge_item_id.split(',').map(id => {
          return parseInt(id);
        });
      }else{
        formRow.fee_item = [parseInt(row.charge_item_id)];
      }
      this.form = formRow;
      this.form.is_long_time = formRow.is_long_time ? true : false;
      // 设置日期范围
      this.validTimeRange = [row.valid_start_time, row.valid_end_time];
      this.dialogVisible = true;
    },

    // 重置表单
    resetForm() {
      this.form = {
        id: null,
        pindex_id: this.pindex_id || '', // 默认选择当前项目
        fee_item: [],
        valid_start_time: '',
        valid_end_time: '',
        is_long_time : 0,
        pay_limit: 100
      };
      this.validTimeRange = [];
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if(this.form.is_long_time){
            this.form.valid_start_time = '';
            this.form.valid_end_time = '';
          }else if (this.validTimeRange && this.validTimeRange.length === 2) {
            // 更新日期范围
            this.form.valid_start_time = this.validTimeRange[0] || '';
            this.form.valid_end_time = this.validTimeRange[1] || '';
          } else {
            this.$message.error('请选择有效时间范围');
            return;
          }

          // 将fee_item数组转换为字符串
          this.form.charge_item_id = Array.isArray(this.form.fee_item)
            ? this.form.fee_item.join(',')
            : this.form.fee_item;
          this.form.is_long_time = this.form.is_long_time ? 1 : 0;

          this.$myhttp
            .post('admin/PartPay/save', this.form, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.$message.success(backdata.data.msg || (this.editMode ? '修改成功' : '添加成功'));
                this.dialogVisible = false;
                this.fetchData();
              } else {
                this.$message.error(backdata.data.msg || (this.editMode ? '修改失败' : '添加失败'));
              }
            })
            .catch((err) => {
              this.$message.error(err.message || (this.editMode ? '修改失败' : '添加失败'));
            });
        } else {
          this.$message.error('请正确填写表单信息');
        }
      });
    },

    // 删除项目
    deleteItem(id) {
      this.$confirm('确认删除该设置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$myhttp
          .post("admin/PartPay/delete", { id }, {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            if (backdata.data.code == 200) {
              this.$message.success(backdata.data.msg || '删除成功');
              this.fetchData();
            } else {
              this.$message.error(backdata.data.msg || '删除失败');
            }
          })
          .catch((err) => {
            this.$message.error(err.message || '删除失败');
          });
      }).catch(() => {
        // 用户取消删除
      });
    },

    // 分页变化
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },

    // 获取费项名称
    getFeeItemName() {
      this.$myhttp
        .get("admin/PartPay/chargeItemList", { }, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.feeItemList = backdata.data.data;
          } else {
            this.$message.error(backdata.data.msg );
          }
        })
        .catch((err) => {
          this.$message.error('请求费项失败');
        });
    }
  }
}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/PartPay.vue